import * as React from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Box from "@mui/material/Box";
import { setUser } from "../store/userSlice";

export default function UserMenu({ user }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    // Handle logout logic here
    handleClose();
    dispatch(setUser(null));
  };

  return (
    <div>
      <Button
        id="user-menu-button"
        aria-controls={open ? "user-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
      >
        Hello {user?.firstName} {user?.lastName}
      </Button>
      <Menu
        id="user-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "user-menu-button",
        }}
      >
        <Box sx={{ padding: "10px" }}>
          <MenuItem onClick={() => navigate("/coming-soon")}>Profile</MenuItem>
          <MenuItem onClick={() => navigate("/coming-soon")}>
            My Orders
          </MenuItem>
          <MenuItem onClick={handleLogout}>Logout</MenuItem>
        </Box>
      </Menu>
    </div>
  );
}
